export default __webpack_public_path__ + "static/media/olga_avatar.df0f1279.jpg";